import Vue from "vue";
import VueI18n from "vue-i18n";
import LangManager from "@/model/lang";
import zhCN from "./zh-cn";
import enUS from "./en-us";
import zhTW from "./zh-tw";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: LangManager.current,
  fallbackLocale: "zh_CN",
  silentTranslationWarn: true,
  messages: {
    zh_CN: zhCN,
    en_US: enUS,
    zh_TW: zhTW,
  },
});

export default i18n;
